var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-checkbox",class:_vm.classes},[_c('label',{staticClass:"v-checkbox__label"},[_c('input',{staticClass:"v-checkbox__input",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"input":_vm.onChange}}),_c('span',{staticClass:"v-checkbox__box"}),_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }